// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GuDn","col":"styles_col__3ay3Y","actions":"styles_actions__1KlZh","conflict":"styles_conflict__1xHxo"};